"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItineraryEventType = void 0;
var ItineraryEventType;
(function (ItineraryEventType) {
    ItineraryEventType["Breakfast"] = "Breakfast";
    ItineraryEventType["Lunch"] = "Lunch";
    ItineraryEventType["Dinner"] = "Dinner";
    ItineraryEventType["Snacks"] = "Snacks";
    ItineraryEventType["Explore"] = "Explore";
    ItineraryEventType["Commute"] = "Commute";
    ItineraryEventType["Activity"] = "Activity";
    ItineraryEventType["Relax"] = "Relax";
    ItineraryEventType["Sightseeing"] = "Sightseeing";
    ItineraryEventType["Shopping"] = "Shopping";
    ItineraryEventType["CulturalExperiences"] = "Cultural Experiences";
    ItineraryEventType["OutdoorAdventures"] = "Outdoor Adventures";
    ItineraryEventType["HistoricalSites"] = "Historical Sites";
    ItineraryEventType["WaterActivities"] = "Water Activities";
    ItineraryEventType["Nightlife"] = "Nightlife";
    ItineraryEventType["WellnessAndSpa"] = "Wellness and Spa";
    ItineraryEventType["FamilyFriendly"] = "Family-Friendly";
    ItineraryEventType["ArtAndMuseums"] = "Art and Museums";
    ItineraryEventType["SportsAndRecreation"] = "Sports and Recreation";
    ItineraryEventType["FestivalsAndEvents"] = "Festivals and Events";
    ItineraryEventType["Other"] = "Other";
})(ItineraryEventType = exports.ItineraryEventType || (exports.ItineraryEventType = {}));
